import { FC } from 'react'

const MobilepayIcon: FC = () => (
  <svg
    width="40"
    height="26"
    viewBox="0 0 40 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="40"
      height="25"
      rx="4"
      fill="#5B79FF"
    />
    <path
      d="M19.5859 16.4294C21.2344 15.9278 22.6289 15.6755 23.7695 15.6731C25.6563 15.6684 27.2375 16.0419 28.5141 16.7934V11.3247C27.2313 10.6622 25.7813 10.3075 24.1648 10.263C22.5808 10.2113 21.0083 10.5498 19.5859 11.2489V16.4294Z"
      fill="white"
    />
    <path
      d="M16.907 10.4694L18.9414 15.303V10.6702C20.0006 10.1013 21.1537 9.72818 22.3453 9.5686C23.5438 9.40766 24.9047 9.43344 26.4297 9.64672L25.3234 7.00844C23.7564 6.89896 22.1857 7.16408 20.7414 7.78188C19.2899 8.40097 17.9836 9.31634 16.9062 10.4694H16.907Z"
      fill="white"
    />
    <path
      d="M20.74 7.04278L19.94 5.10137C19.8518 4.88578 19.7219 4.6897 19.5578 4.52432C19.3937 4.35895 19.1986 4.22753 18.9837 4.13756C18.7688 4.0476 18.5383 4.00086 18.3053 4.00001C18.0724 3.99916 17.8415 4.04422 17.626 4.13262L12.0947 6.41231C11.8795 6.50147 11.6839 6.63216 11.5192 6.79691C11.3545 6.96167 11.2239 7.15727 11.1348 7.37253C11.0457 7.58779 10.9999 7.81849 11 8.05146C11.0001 8.28442 11.0461 8.51509 11.1354 8.73028L16.4588 21.6467C16.5471 21.8623 16.677 22.0584 16.8411 22.2237C17.0052 22.3891 17.2002 22.5205 17.4151 22.6105C17.63 22.7005 17.8605 22.7472 18.0935 22.748C18.3265 22.7489 18.5573 22.7038 18.7729 22.6154L24.3041 20.3357C24.5194 20.2467 24.715 20.116 24.8798 19.9513C25.0446 19.7866 25.1753 19.591 25.2645 19.3757C25.3537 19.1605 25.3996 18.9297 25.3995 18.6967C25.3995 18.4637 25.3535 18.233 25.2643 18.0178L24.6041 16.4162C24.384 16.4026 24.1636 16.3921 23.9432 16.385C23.7336 16.3809 23.5239 16.3804 23.3143 16.3834L24.1729 18.467C24.2027 18.5388 24.2181 18.6158 24.2181 18.6935C24.2181 18.7713 24.2028 18.8483 24.1731 18.9201C24.1433 18.992 24.0997 19.0572 24.0447 19.1122C23.9897 19.1672 23.9244 19.2107 23.8525 19.2404L18.3213 21.5201C18.1761 21.5794 18.0134 21.5787 17.8688 21.518C17.7242 21.4574 17.6096 21.3418 17.5502 21.1967L12.2268 8.28184C12.1969 8.21008 12.1815 8.13314 12.1814 8.05542C12.1813 7.9777 12.1965 7.90072 12.2262 7.82889C12.2559 7.75706 12.2994 7.69178 12.3544 7.63679C12.4093 7.5818 12.4745 7.53817 12.5463 7.5084L18.0775 5.22871C18.1495 5.19922 18.2265 5.18419 18.3042 5.18448C18.3819 5.18478 18.4588 5.20039 18.5305 5.23043C18.6022 5.26047 18.6673 5.30434 18.722 5.35955C18.7767 5.41475 18.82 5.4802 18.8494 5.55215L19.658 7.51309C19.908 7.39121 20.0994 7.30371 20.2338 7.24981C20.3682 7.1959 20.5369 7.12715 20.74 7.04278Z"
      fill="white"
    />
  </svg>
)

export default MobilepayIcon
